import { FunnelIcon } from '@heroicons/react/20/solid';

import NeedsApprovalRow from '../components/NeedsApprovalRow';
import useNeedsApprovalQueue from '../hooks/useNeedsApprovalQueue';

import LoadingState from '@/components/LoadingState';

// Needs-approval queue: shifts with a pending decision, one row each, with a
// fraction column whose sub-state (Hired / For Hired / For approval) is
// colour-distinguished.

type Props = { agencyId: number };

const NeedsApprovalTab = ({ agencyId }: Props) => {
  const { data, isLoading, isError } = useNeedsApprovalQueue(agencyId);
  const shifts = data?.shifts ?? [];

  return (
    <div>
      <div className="dashv2-queue-title">
        <h2 className="dashv2-queue-heading">Needs approval</h2>
        <button type="button" className="dashv2-showbtn" disabled>
          <FunnelIcon />
          Show
        </button>
      </div>

      {isLoading && !data ? (
        <LoadingState />
      ) : isError ? (
        <div className="dashv2-queue-empty">
          Unable to load the queue. Please retry.
        </div>
      ) : shifts.length === 0 ? (
        <div className="dashv2-queue-empty">Nothing awaiting approval. 🎉</div>
      ) : (
        <div className="dashv2-queue-list">
          {shifts.map((shift) => (
            <NeedsApprovalRow key={shift.job_id} shift={shift} />
          ))}
        </div>
      )}
    </div>
  );
};

export default NeedsApprovalTab;
